export const SET_ALL_DATA_OF_ADMIN_APPOINTMENTS = "SET_ALL_DATA_OF_ADMIN_APPOINTMENTS";
export const SET_APPOINTMENTS_ADMIN_APPOINTMENTS = "SET_APPOINTMENTS_ADMIN_APPOINTMENTS";
export const SET_FILTERED_ADMIN_APPOINTMENTS = "SET_FILTERED_ADMIN_APPOINTMENTS";
export const SET_PAGES_DATA_ADMIN_APPOINTMENTS = "SET_PAGES_DATA_ADMIN_APPOINTMENTS";
export const SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS = "SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS";
export const RESET_ALL_ADMIN_APPOINTMENTS_DATA = "RESET_ALL_ADMIN_APPOINTMENTS_DATA";
export const PREPEND_NEW_APPOINTMENT_ADMIN = "PREPEND_NEW_APPOINTMENT_ADMIN";

export const SET_HAS_MORE_PAGE_APPOINTMENTS = 'SET_HAS_MORE_PAGE_APPOINTMENTS'